import React from 'react'
import { Field } from 'redux-form'
import { GridList, GridTile } from 'material-ui/GridList'
import IconButton from 'material-ui/IconButton'
import ClearIcon from 'material-ui/svg-icons/content/clear'
import PhotoLibrary from 'material-ui/svg-icons/image/photo-library'
import FlatButton from 'material-ui/FlatButton'
import { themeColors } from '../styles/theme'

const styles = {
  gridListContainer: {
    marginTop: '10px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
  },
  gridList: {
    // width: 500,
    // height: 450,
    overflowY: 'auto',
  },
  imgBtn: {
    border: '0.5px solid',
    marginTop: 20,
  },
}

const renderPreviewSingleImage = ({ input }) => (
  <img src={input.value} height="auto" width="100%" />
)

const MultiImages = ({
  fields,
  meta: { touched, error, submitFailed, submitting },
}) => {
  // Read file as base64 an push it to list of images...
  const handleChange = e => {
    const file = e.target.files[0]
    const reader = new FileReader()

    reader.addEventListener('load', e => {
      fields.push(e.target.result)
    })
    reader.readAsDataURL(file)
  }

  return (
    <div>
      <FlatButton
        label="Immagini aggiuntive"
        disabled={submitting}
        labelPosition="before"
        containerElement="label"
        primary={true}
        style={styles.imgBtn}
        icon={<PhotoLibrary />}>
        <input
          type="file"
          onChange={handleChange}
          style={{ display: 'none' }}
        />
      </FlatButton>

      <div style={styles.gridListContainer}>
        <GridList cellHeight={180} style={styles.gridList}>
          {fields.map((image, index) => (
            <GridTile
              key={index}
              title={' '}
              actionIcon={
                <IconButton
                  disabled={submitting}
                  onClick={() => fields.remove(index)}>
                  <ClearIcon color={themeColors.secondary} />
                </IconButton>
              }>
              <Field name={image} component={renderPreviewSingleImage} />
            </GridTile>
          ))}
        </GridList>
      </div>
    </div>
  )
}

export default MultiImages



// WEBPACK FOOTER //
// ./src/common/MultiImages.js